import { SVGProps, Ref, forwardRef } from 'react';

export const WalletFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M23.896 8c-.39-4.303-2.052-5-7.896-5H8C2.156 3 .494 3.697.104 8H9.52c.127.587.308 1.1.539 1.516.434.782 1.002 1.184 1.942 1.184s1.508-.402 1.942-1.184c.231-.415.412-.93.538-1.516zm.092 1.8h-8.186c-.668 1.587-1.864 2.7-3.802 2.7s-3.134-1.113-3.802-2.7H.012C-.012 10.866 0 11.933 0 13c0 7 1 8 8 8h8c7 0 8-1 8-8 0-1.066.011-2.134-.012-3.2"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
WalletFilledSize24Glyph.displayName = 'WalletFilledSize24Glyph';
